export default __webpack_public_path__ + "static/media/hero-featured-image.24bb70b0.png";